import { Component, Input, SimpleChanges } from "@angular/core";
import { DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { environment } from "../../../../../environments/environment";
import { formatCurrency } from "@ponder-shared/utils/numberFormatter";
import { canFlip } from "@ponder-shared/utils/cardInfo";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { NgClass } from "@angular/common";

@Component({
    selector: "deck-focused-card",
    imports: [NgClass],
    templateUrl: "./deck-focused-card.component.html"
})
export class DeckFocusedCardComponent {
    @Input() focusedCard?: DeckCard;

    public readonly flipIconSvg = SvgIconMap.get(SvgIcon.Flip)!;
    private isFlipped: boolean = false;

    public ngOnChanges(changes: SimpleChanges): void {
        this.isFlipped = false;
    }

    public getImageUrl(): string {
        if (this.focusedCard) {
            return `${environment.ponderImageBaseUrl}/card/medium/${this.isFlipped ? "back" : "front"}/${this.focusedCard.card.item.id!}.jpg`;
        } else {
            // todo
            return "";
        }
    }

    public getCollectedCount(): string {
        var count = this.focusedCard?.card?.collected?.count ?? 0;
        return count ? `${count}` : "";
    }

    public getSpecialCollectedCount(): string {
        var count =  this.focusedCard?.card?.collected?.specialCount ?? 0;
        return count ? `${count}` : "";
    }

    public hasPrice(): boolean {
        return this.focusedCard?.card?.price?.normalUSD ? true : false;
    }

    public hasSpecialPrice(): boolean {
        return this.focusedCard?.card?.price?.specialUSD ? true : false;
    }

    public getPrice(): string {
        var price = this.focusedCard?.card?.price?.normalUSD;
        return price ? formatCurrency(price) : "";
    }

    public getSpecialPrice(): string {
        var price = this.focusedCard?.card?.price?.specialUSD;
        return price ? formatCurrency(price) : "";
    }

    public canCardFlip(): boolean {
        if (this.focusedCard) {
            return canFlip(this.focusedCard!.card.item);
        }

        return false;
    }

    public flipFace(): void {
        this.isFlipped = !this.isFlipped;
    }
}